<div>
    <input type="text" [(ngModel)]="searchTerm" placeholder="Search country">
    <select>
      <option *ngFor="let country of countries | countryFilter:searchTerm" [value]="country.alpha2Code">
        <img [src]="country.flag" alt="Flag of {{ country.name }}" width="20" height="15">
        {{ country.name }} ({{ country.alpha2Code }}) +{{ country.callingCodes[0] }}
      </option>
    </select>
  </div>